import { useState, useEffect } from "react";
import { loadStoreLedgerList } from "../services/storeLedgerService";

const useStoreLedgerList = () => {
    const [ledgerList, setLedgerList] = useState([]);
    const [isIssuedIndentDataLoaded, setIsIssuedIndentDataLoaded] = useState(false);

    // Fetch department data
    const fetchLedgerList = async (selectedID = null) => {
        
        const para = { p_companyid: localStorage.getItem("companyid"), p_plantid: 1 };

        try {
            const data = await loadStoreLedgerList(para);
            if (data && data.length > 0) {
                setLedgerList(data);
                setIsIssuedIndentDataLoaded(true);
            }
        } catch (error) {
            // CallMessage("error", error.message, "Error");
        }
    };

    // Load departments when the component mounts
    useEffect(() => {
        if (!isIssuedIndentDataLoaded) {
            fetchLedgerList();
        }
    }, [isIssuedIndentDataLoaded]);

    // Function to load department based on selected ID
    const loadLedgerListByDateRange = async (selectedID) => {
        await fetchLedgerList(selectedID);
    };

    return {
        ledgerList,
        setLedgerList,
        loadLedgerListByDateRange,
    };
};

export default useStoreLedgerList;